export const TRIAL_USER_LEVEL = 'trial';
export const FREE_USER_LEVEL = 'free';
export const PAID_USER_LEVEL = 'paid';
export const TRIAL_RESTRICTION_TYPE = 'trial';
export const PAID_RESTRICTION_TYPE = 'login';
